// app/javascript/controllers/department_managers_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["reportToSelect"]

  load(event) {
    const designationId = event.target.value
    if (!designationId) return
    console.log(designationId);
    fetch(`/hris/employees/designation_wise_users?designation_id=${designationId}`)
      .then(response => {
        if (!response.ok) throw new Error("Network error")
        return response.json()
      })
      .then(data => {
        this.reportToSelectTarget.innerHTML = ""

        const defaultOption = document.createElement("option")
        defaultOption.value = ""
        defaultOption.text = "Select Report To"
        this.reportToSelectTarget.appendChild(defaultOption)

        data.forEach(user => {
          const option = document.createElement("option")
          option.value = user.val
          option.text = user.txt
          this.reportToSelectTarget.appendChild(option)
        })
      })
      .catch(error => {
        console.error("Fetch error:", error)
      })
  }
}
